export { default } from './clinicworkspace';
export { default as ClinicPatients } from './ClinicPatients';
